import './AgentAuditOperationDetail.css';
import { formatMarkdown } from './AgentAuditOperationDetailHelpers';

// ─── Sub-components ───────────────────────────────────────────────────────────
function ToolArgsList({ args }) {
  if (!Array.isArray(args) || args.length === 0) return null;

  return (
    <div className="tool-block">
      <div className="input-title tool-block-title">Args</div>
      <div className="tool-args-list">
        {args.map((a, idx) => {
          const argName = a?.name != null ? String(a.name) : '';
          const argType = a?.type != null ? String(a.type) : '';
          const required = Boolean(a?.required);
          const description = a?.description != null ? String(a.description) : '';

          return (
            <div key={`${argName}-${idx}`} className="tool-arg-row">
              <div className="tool-arg-header">
                <span className="tool-arg-name">{argName}</span>
                {argType && <span className="tool-arg-type">{argType}</span>}
                <span className="tool-arg-required">{required ? 'required' : 'optional'}</span>
              </div>
              {description && <div className="tool-arg-desc">{description}</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}

function ToolConfig({ config }) {
  if (config == null) return null;
  const text = typeof config === 'string' ? config : JSON.stringify(config, null, 2);
  return (
    <div className="tool-block">
      <div className="input-title tool-block-title">Config</div>
      <pre className="tool-pre">{text}</pre>
    </div>
  );
}

function ToolTextBlock({ label, value }) {
  if (!value) return null;
  return (
    <div className="tool-block">
      <div className="input-title tool-block-title">{label}</div>
      <div
        className="tool-block-content"
        dangerouslySetInnerHTML={{ __html: formatMarkdown(String(value)) }}
      />
    </div>
  );
}

function AvailableToolItem({ tool, idx }) {
  const kind = tool?.kind ? String(tool.kind) : '';
  const name = tool?.name ? String(tool.name) : '';
  const type = tool?.type ? String(tool.type) : '';
  const main = name || type || 'tool';
  const title = `${main}${kind ? ` (${kind})` : ''}`;

  return (
    <details key={`${title}-${idx}`} open={false} className="available-tool-item">
      <summary className="available-tools-summary" style={{ fontWeight: 600 }}>
        <span className="tool-caret" aria-hidden="true">
          ▶
        </span>
        <span>{title}</span>
      </summary>

      <div className="available-tool-body">
        {tool?.kind && (
          <div className="tool-meta-line">
            <span style={{ fontWeight: 600 }}>Kind:</span> {kind}
          </div>
        )}
        {tool?.name && (
          <div className="tool-meta-line">
            <span style={{ fontWeight: 600 }}>Name:</span> {name}
          </div>
        )}
        {tool?.type && (
          <div className="tool-meta-line">
            <span style={{ fontWeight: 600 }}>Type:</span> {type}
          </div>
        )}

        <ToolTextBlock label="Description" value={tool?.description} />
        <ToolTextBlock label="Instruction" value={tool?.instruction} />
        <ToolArgsList args={tool?.args} />
        <ToolConfig config={tool?.config} />
      </div>
    </details>
  );
}

// ─── Main export ──────────────────────────────────────────────────────────────
function AvailableTools({ tools }) {
  if (!Array.isArray(tools) || tools.length === 0) return null;

  return (
    <details open={false} className="input-block available-tools-section">
      <summary className="input-title available-tools-summary">
        <span className="tool-caret" aria-hidden="true">
          ▶
        </span>
        <span>
          Available tools <span style={{ opacity: 0.7 }}>({tools.length})</span>
        </span>
      </summary>

      <div className="available-tools-list">
        {tools.map((tool, idx) => (
          <AvailableToolItem key={idx} tool={tool} idx={idx} />
        ))}
      </div>
    </details>
  );
}

export default AvailableTools;
